import * as Joi from "joi";
import i18n from "src/i18n";
import parsePhoneNumber from "libphonenumber-js";

const ADDRESS = Joi.object()
  .keys({
    state: Joi.string()
      .label(i18n.t("State/Region"))
      .empty("")
      .allow(null, "")
      .max(40)
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
        "string.max": `{#label} ${i18n.t("validationErrors.maxChar", { length: 40, })}`,
      }),
    city: Joi.string()
      .required()
      .empty("")
      .label(i18n.t("City"))
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
      }),
    details: Joi.string()
      .empty("")
      .label(i18n.t("Details"))
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
      }),
    location: Joi.object()
      .keys({
        coordinates: Joi.array()
          .min(2)
          .required()
          .messages({
            "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
          }),
      })
      .required(),
    area: Joi.string()
      .label(i18n.t("District"))
      .empty("")
      .required()
      .max(40)
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
        "string.max": `{#label} ${i18n.t("validationErrors.maxChar", {
          length: 40,
        })}`,
      }),
    street: Joi.string()
      .empty("")
      .required()
      .label(i18n.t("Street"))
      .max(40)
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
        "string.max": `{#label} ${i18n.t("validationErrors.maxChar", {
          length: 40,
        })}`,
      }),
    buildingNumber: Joi.string()
      .empty("")
      .optional()
      .allow(null, "")
      .label(i18n.t("Building No."))
      .max(10)
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
        "string.max": `{#label} ${i18n.t("validationErrors.maxChar", {
          length: 10,
        })}`,
      }),
    postcode: Joi.string()
      .empty("")
      .optional()
      .allow(null, "")
      .label(i18n.t("Postcode"))
      .max(30)
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
        "string.max": `{#label} ${i18n.t("validationErrors.maxChar", {
          length: 30,
        })}`,
      }),
    shortAddress: Joi.string()
      .empty("")
      .optional()
      .label(i18n.t("Short Address Code"))
      .length(8)
      .allow(null, "")
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
        "string.length": `{#label} ${i18n.t("validationErrors.lengthChar", {
          length: 8,
        })}`,
      }),
  })
  .required();



export const addWarehouseSchema = () =>
  Joi.object({
    name: Joi.string()
      .required()
      .empty("")
      .label(i18n.t("Name"))
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
      }),
    phone: Joi.string()
      .label(i18n.t("Phone"))
      .empty("")
      .required()
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
      })
      .custom((value, helper) => {
        const parsedPhone = parsePhoneNumber(value, { extract: true });
        if (!parsedPhone || !parsedPhone.isValid())
          return helper.message(i18n.t("validationErrors.isValidPhone"));
        return true;
      }),
    address: ADDRESS,
  });

export const updateWarehouseSchema = (isAdmin) =>
  Joi.object({
    warehouseId: isAdmin ? Joi.string().optional() : Joi.string().required(),
    name: Joi.string()
      .required()
      .empty("")
      .label(i18n.t("Name"))
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
      }),
    phone: Joi.string()
      .required()
      .label(i18n.t("Phone"))
      .empty("")
      .required()
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
      })
      .custom((value, helper) => {
        const parsedPhone = parsePhoneNumber(value, { extract: true });
        if (!parsedPhone || !parsedPhone.isValid())
          return helper.message(i18n.t("validationErrors.isValidPhone"));
        return true;
      }),
    address: ADDRESS,
  });
